export class AuthForbiddenError extends Error {
  constructor() {
    super('Error permission')
  }
}
